// staffDashboard.tsx

import React from "react";
import {
  Grid,
  SimpleGrid,
  rem,
  Text,
  Card,
  RingProgress,
  Group,
  useMantineTheme,
  Progress,
  Center,
  Paper,
  Checkbox,
  Stack,
  Avatar,
} from "@mantine/core";
import { IconArrowUpRight, IconArrowDownRight } from "@tabler/icons-react";
import { LineChart } from "@mantine/charts";
import { data } from "./data";
import classes from "./staffDashboard.module.css";
import Header from "../static/Header";

// <div className={classes.adminContainer}>
// <ScrollArea className={classes.parentContainer}>
//   <div className={classes.searchBarContainer}>
//     <SearchBar
//       isLoading={isLoading}
//       resetPage={resetPage}
//       changeTableState={changeTableState}
//       search={search}
//       handleSearch={handleSearch}
//       setShowFilterOptions={setShowFilterOptions}
//       showFilterOptions={showFilterOptions}
//       selectedFilters={selectedFilters}
//       setSelectedFilters={setSelectedFilters}
//       checkboxesFilter={checkboxesFilter}
//     />

//     <div className={classes.addButtonContainer}>
//       <Button onClick={handleAddAdmins}>
//         <IconUserPlus />
//         Create Banner
//       </Button>
//     </div>
//   </div>
// </ScrollArea>
// </div>

const icons = {
  up: IconArrowUpRight,
  down: IconArrowDownRight,
};

const progress = [
  {
    label: "Monthly KPI",
    stats: "65%",
    progress: 65,
    color: "teal",
    icon: "up",
  },
  {
    label: "New Customers",
    stats: "2,550",
    progress: 72,
    color: "blue",
    icon: "up",
  },
  {
    label: "Progression Rate    ",
    stats: "4,735",
    progress: 52,
    color: "red",
    icon: "down",
  },
] as const;

export function StaffDashboard() {
  const theme = useMantineTheme();
  const completed = 1887;
  const total = 2334;

  const stats = progress.map((stat) => {
    const Icon = icons[stat.icon];
    return (
      <Paper withBorder radius="md" p="xs" key={stat.label}>
        <Group>
          <RingProgress
            size={80}
            roundCaps
            thickness={8}
            sections={[{ value: stat.progress, color: stat.color }]}
            label={
              <Center>
                <Icon
                  style={{ width: rem(20), height: rem(20) }}
                  stroke={1.5}
                />
              </Center>
            }
          />

          <div>
            <Text c="dimmed" size="xs" tt="uppercase" fw={700}>
              {stat.label}
            </Text>
            <Text fw={700} size="xl">
              {stat.stats}
            </Text>
          </div>
        </Group>
      </Paper>
    );
  });

  return (
    <>
      <Header title="Staff Dashboard" />
      <div className={classes.dashboardContainer}>
        <div className={classes.componentContainer}>
          {/* 1st Line */}
          <div className={classes.kpiContainer}>
            <SimpleGrid>
              <Grid>
                <Grid.Col span={4}>
                  <Card
                    withBorder
                    p="xl"
                    radius="md"
                    className={classes.piechartCard}
                  >
                    <div className={classes.inner}>
                      <div>
                        <Avatar color="violet" radius="xl">
                          JL
                        </Avatar>
                        <Text fz="xl" className={classes.label_1}>
                          Joshua Lim
                        </Text>
                        <div>
                          <Text className={classes.lead} mt={30}>
                            xxx@gmail.com
                          </Text>
                          <Text fz="xs">Staff ID: 001</Text>
                          <div>
                            <Text fz="xl" className={classes.label_2} mt={30}>
                              KPI Target: 30,000
                            </Text>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </Grid.Col>
                <Grid.Col span={3.8}>
                  <Card
                    withBorder
                    radius="md"
                    padding="xl"
                    bg="var(--mantine-color-body)"
                  >
                    <Text fz="xl" tt="uppercase" fw={700}>
                      Welcome Back !
                    </Text>
                    <Text fz="lg" fw={500}>
                      Joshua
                    </Text>
                    <Text fz="lg" fw={500}>
                      Current KPI Target:
                    </Text>
                    <Stack mt={25}>
                      <Checkbox
                        defaultChecked
                        color="blueviolet"
                        label="Sales"
                      />
                      <Checkbox
                        defaultChecked
                        color="blueviolet"
                        label="Sign Up"
                      />
                      <Checkbox
                        defaultChecked
                        color="blueviolet"
                        label="Reward"
                      />
                    </Stack>
                  </Card>
                </Grid.Col>
                <Grid.Col span={4}>
                  <Card
                    withBorder
                    radius="md"
                    padding="xl"
                    bg="var(--mantine-color-body)"
                  >
                    <Text fz="xs" tt="uppercase" fw={700}>
                      Target
                    </Text>
                    <Text fz="lg" fw={500}>
                      RM6,000 / RM10.000
                    </Text>
                    <Progress
                      value={60}
                      mt="md"
                      size="lg"
                      radius="xl"
                      color="blueviolet"
                    />
                  </Card>
                </Grid.Col>
              </Grid>
            </SimpleGrid>
          </div>
          <div className={classes.ringtrackerContainer}>
            <SimpleGrid cols={{ base: 1, sm: 3 }}>{stats}</SimpleGrid>
          </div>

          {/* 2nd Line */}
          <div className={classes.secondColumn}>
            <SimpleGrid>
              <Grid>
                {/* 3rd Line */}
                <Grid.Col>
                  <Card
                    withBorder
                    radius="md"
                    padding="xl"
                    bg="var(--mantine-color-body)"
                  >
                    <LineChart
                      h={300}
                      w={1200}
                      data={data}
                      dataKey="date"
                      series={[
                        { name: "Sales", color: "indigo.6" },
                        { name: "SignUp", color: "blue.6" },
                        { name: "Reward", color: "teal.6" },
                      ]}
                    />
                  </Card>
                </Grid.Col>
              </Grid>
            </SimpleGrid>
          </div>
        </div>
      </div>
    </>
  );
}

export default StaffDashboard;
